<template>
  <div>
    <form @submit.prevent="submit()">      
      <div class="mdn-Row">
        <!-- <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormSelectComponent 
            :name="'ctrl_processo_id'"
            :listaDeOptions="listaDeMacroProcessos"
            v-model="formulario.ctrl_processo_id"
            :optionLabel="'processo'"
            :placeholder="'Macro Processo'"
            :error="validationErrors.first('ctrl_processo_id')"
            data-vv-as="Macro Processo"
          />
        </div> -->

        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormSelectComponent
              :name="'ctrl_tipo_aging_id'"
              :listaDeOptions="listaDeTiposAgings"
              v-model="formulario.ctrl_tipo_aging_id"
              :optionLabel="'tipo'"
              :placeholder="'Tipo de Aging'"
              :error="validationErrors.first('ctrl_tipo_aging_id')"
              data-vv-as="Tipo de Aging"
          />
        </div>
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormSelectComponent 
            :name="'ctrl_workflow_id'"
            :listaDeOptions="listaDeWorkflows"
            v-model="formulario.ctrl_workflow_id"
            :optionLabel="'workflow'"
            :placeholder="'Workflow'"
            :error="validationErrors.first('ctrl_workflow_id')"
            data-vv-as="Workflow"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormSelectComponent 
            :name="'ctrl_processo_hierarquia_id'"
            :listaDeOptions="listaDeHierarquiasFiltradas"
            v-model="formulario.ctrl_processo_hierarquia_id"
            :optionLabel="'hierarquia'"
            :placeholder="'Hierarquia Principal'"
            :error="validationErrors.first('ctrl_processo_hierarquia_id')"
            data-vv-as="Hierarquia Principal"
            :somenteLeitura="!formulario.ctrl_workflow_id"
          />
        </div>

        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormSelectComponent 
            :name="'ctrl_hierarquia_pai_id'"
            :listaDeOptions="listaDeProcessosHierarquias"
            v-model="formulario.ctrl_hierarquia_pai_id"
            :optionLabel="'hierarquia'"
            placeholder="Hierarquia Pai"
            :error="validationErrors.first('ctrl_hierarquia_pai_id')"
            data-vv-as="Hierarquia Pai"
            :somenteLeitura="true"
          />
        </div>

        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormSelectComponent 
            :name="'ctrl_hierarquia_filho_id'"
            :listaDeOptions="listaDeProcessosHierarquias"
            v-model="formulario.ctrl_hierarquia_filho_id"
            :optionLabel="'hierarquia'"
            placeholder="Hierarquia Filho"
            :error="validationErrors.first('ctrl_hierarquia_filho_id')"
            data-vv-as="Hierarquia Filho"
            :somenteLeitura="true"
          />
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent 
            type="number" 
            min="0"
            :name="'aging'"
            v-model="formulario.aging"
            :placeholder="'Aging'"
            data-vv-as="Aging"
            v-validate="'integer|required|min:0'"
            :error="validationErrors.first('aging')"
         />
        </div>

        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent 
            type="number" 
            min="0"
            :name="'ordem'"
            v-model="formulario.ordem"
            :placeholder="'Ordem de Exibição'"
            data-vv-as="Ordem"
            v-validate="'integer|required'"
            :error="validationErrors.first('ordem')"
         />
        </div>
      </div>      

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent 
            type="text" 
            :name="'processo'"
            v-model="formulario.processo" 
            :placeholder="'Nome do Processo'"
            data-vv-as="Nome do Processo"
            v-validate="'required|max:255'"
            :error="validationErrors.first('processo')"
          />
        </div>
      </div>  

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <div class="container-botoes">
            <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize" type="submit">
              {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
            </button>
            <button class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize" type="button" @click="fecharModal()">Cancelar</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "FormularioProcessoComponent",

  props: {
    tipoFormulario: { type: String, default: 'salvar' },
    processo: { type: Object, required: false }
  },

  created () {
    this.listarTipoAgings();
    this.listarProcessosHierarquias();
    this.listarWorkflows();
  },

  data () {
    return {
      formulario: this.processo || {
        processo: '',
        ctrl_processo_id: '',
        ctrl_workflow_id: '',
        ctrl_processo_hierarquia_id: '',
        ctrl_hierarquia_pai_id: '',
        ctrl_hierarquia_filho_id: '',
        ctrl_tipo_aging_id: '',
        aging: 0,
        ordem: 0
      }
    }
  },

  computed: {
    ...mapGetters('ctrlProcessos', [
      'listaDeMacroProcessos',
      'listaDeProcessosHierarquias',
      'listaDeTiposAgings'
    ]),

    ...mapGetters('ctrlWorkflow', [
      'listaDeWorkflows',
      'loadingWorkflows'
    ]),
    
    listaDeHierarquiasFiltradas () {
      const workflowId = this.formulario.ctrl_workflow_id

      if (!workflowId) {
        return this.listaDeProcessosHierarquias
      }

      return this.listaDeProcessosHierarquias.filter(h => 
        h.ctrl_workflow_id === workflowId
      )
    }
  },

  watch: {
    'formulario.ctrl_processo_hierarquia_id'(novoId) {
      if (!novoId) return
      const hierarquia = this.listaDeProcessosHierarquias.find(h => h.id === novoId)
      if (hierarquia) {
        this.formulario.ctrl_hierarquia_pai_id = hierarquia.ctrl_processo_hierarquia_pai_id
        this.formulario.ctrl_hierarquia_filho_id = hierarquia.ctrl_processo_hierarquia_filho_id
      }
    }
  },

  methods: {
    ...mapActions('ctrlProcessos', [
      'salvarProcesso',
      'atualizarProcesso',
      'listarTipoAgings',
      'listarProcessosHierarquias'
    ]),
    ...mapActions('ctrlWorkflow', [
      'listarWorkflows',
    ]),

    submit () {
      this.$validator.validateAll().then(async result => {
        if (!result) return;

        if(this.tipoFormulario === 'salvar') {
          const resp = await this.salvarProcesso(this.formulario)
          if(!resp) return
        } else {
          const resp = await this.atualizarProcesso(this.formulario)
          if(!resp) return
        }

        this.limparCampos()
        this.fecharModal()
      })
    },

    limparCampos () {
      this.formulario = {
        processo: '',
        ctrl_processo_id: '',
        ctrl_workflow_id: '',
        ctrl_processo_hierarquia_id: '',
        ctrl_hierarquia_pai_id: '',
        ctrl_hierarquia_filho_id: '',
        ctrl_tipo_aging_id: '',
        aging: 0,
        ordem: 0
      }
      this.$validator.reset()
    },

    fecharModal () {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  }
}
</script>
